import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import {
  ITaskTemplateAddParams,
  ITaskTemplateCreateResponse,
  ITaskTemplatePageRequest,
  ITaskTemplatePageItem,
  ITaskTemplateDetailRequest,
  ITaskTemplateDetail,
  ITaskTemplateItem,
  IDutyTempConfigContract,
} from '../../../../types/system/base/task-template';

const hostUrl = getHostbaseUrl();

/**
 * 创建任务模板
 * @param params 创建参数
 */
export async function createTaskTemplate(params: ITaskTemplateAddParams) {
  try {
    const { code, message } = await Http.post<ITaskTemplateCreateResponse>(
      `${hostUrl}/side/duty-temp/create`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return { data: true };
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 查询任务模板分页列表
 * @param params 查询参数
 */
export async function queryTaskTemplatePage(params: ITaskTemplatePageRequest) {
  try {
    const { code, context, message } = await Http.get<{data: ITaskTemplatePageItem[];total: number}>(
      `${hostUrl}/side/duty-temp/page`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return context || {
        data: [],
        total: 0,
      };
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 删除任务模板
 * @param params 输入参数
 */
export async function deleteTaskTemplate(params: { id: number }) {
  try {
    const { code, message } = await Http.get<any>(
      `${hostUrl}/side/duty-temp/delete`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return true;
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 查询任务模板详情
 * @param params 查询参数
 */
export async function queryTaskTemplateDetail(params: ITaskTemplateDetailRequest) {
  try {
    const { code, context, message } = await Http.get<ITaskTemplateDetail>(
      `${hostUrl}/side/duty-temp/detail`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return { data: context };
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 创建任务模板
 * @param params 修改参数
 */
export async function updateTaskTemplate(params: ITaskTemplateAddParams) {
  try {
    const { code, message } = await Http.post<ITaskTemplateCreateResponse>(
      `${hostUrl}/side/duty-temp/update`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return { data: true };
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 获取任务模板列表
 */
export async function queryTaskTemplateList(params?: {industryId?: number; dutyType?: number}) {
  try {
    const { code, context, message } = await Http.get<ITaskTemplateItem[]>(
      `${hostUrl}/side/duty-temp/list`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return { data: context || [] };
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 根据任务模版id查询模版配置合同信息
 */
export async function queryDutyTempConfigContract(tempId: number) {
  try {
    const { code, context, message } = await Http.get<IDutyTempConfigContract[]>(
      `${hostUrl}/side/duty-temp/config-contract/info`,
      { tempId },
    );

    if (code === EAxiosResponseCode.Succeed) {
      return context || [] as IDutyTempConfigContract[];
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 全部模版列表
 */
export async function queryDutyTempListAll(companyId: number, dutyType: number) {
  try {
    const { code, context, message } = await Http.get<ITaskTemplateItem[]>(
      `${hostUrl}/side/duty-temp/list-all`,
      {
        companyId,
        dutyType,
      },
    );

    if (code === EAxiosResponseCode.Succeed) {
      return { data: context || [] };
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}
